import React, { Component } from 'react';
import ModuleContainer from '../../../components/ModuleContainer';
import ViewHeader from '../../../components/ViewHeader';
import { Tabs, Tab } from 'react-bootstrap';
import BannerTab from './BannerTab';
import { ANNOUNCEMENT, SUBSCRIBED_MEMBERS, UNSUBSCRIBED_MEMBERS } from '../../../../utils/constants';


class BannerAnnouncement extends Component {

    render() {
        return (
            <ModuleContainer>
                <ViewHeader title={ANNOUNCEMENT} />

                <Tabs defaultActiveKey="subscribed" transition={false} id="banner" >
                    <Tab eventKey="subscribed" title={SUBSCRIBED_MEMBERS} className="tabs-announcement" unmountOnExit>
                        <BannerTab isSubscribed={true} />
                    </Tab>
                    <Tab eventKey="unsubscribed" title={UNSUBSCRIBED_MEMBERS} unmountOnExit>
                        <BannerTab isSubscribed={false} />
                    </Tab>
                </Tabs>
            </ModuleContainer>
        );
    }
}

export default BannerAnnouncement;